export default __webpack_public_path__ + "static/blog-03-500x338-abf5f53cf98ab39126804f0b9bc52da0.jpg";